import { requestApiGet } from "../api/BacklogApiEndpoint";
import type { BacklogConfig } from "../contracts/BacklogConfig";
import type { BacklogApiContext } from "../contracts/api/BacklogApiContext";
import type { BacklogResponse } from "../contracts/api/BacklogResponse";
import type { RateLimit } from "../entities/RateLimit";

/**
 * Get Rate Limit レート制限情報の取得
 *
 * Return information about the rate limit currently applied to you.
 */

export function getRateLimit(
	config: BacklogConfig,
	context?: BacklogApiContext,
): Promise<BacklogResponse<RateLimit>> {
	return requestApiGet({
		config,
		path: "rateLimit",
		params: undefined,
		context,
	});
}
